<template>
  <div
    class="category-book-slider">
    <div class="category-book-slider__container">
      <slot name="header" :total-books="this.category.books_count" :title="this.category.title">
        <b-headline
          type="h3"
          typography="h3"
          class="category-book-slider__headline mb-4 m:mb-2"
          v-html="headline" />

        <b-subheadline
          class="category-book-slider__subheadline mb-8"
          v-html="subheadline" />
      </slot>

      <div class="category-book-slider__books">
        <book-slider-with-arrows
          :category-title="category.title"
          :books-count="category.books_count"
          :books="category.books"
          :are-books-linked="areBooksLinked"
          :show-cta-card="clickableBooks" />
      </div>
    </div>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline/index";
import BSubheadline from "@/component-library/b-subheadline/index";
import BookSliderWithArrows from "@/component-library/book-slider-with-arrows/index";

export default {
  name: "CategoryBookSlider",
  components: {
    BHeadline,
    BSubheadline,
    BookSliderWithArrows
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    clickableBooks: {
      type: Boolean,
      default: true
    },
    areBooksLinked: { type: Boolean, default: true }
  },
  computed: {
    headline() {
      return this.$t("headline", {
        categoryName: this.category.title
      });
    },
    subheadline() {
      return this.$t("subheadline", {
        booksCount: this.category.books_count
      });
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Most popular in <mark>{categoryName}</mark>",
        subheadline: "Read or listen to {booksCount} titles in this category"
      },
      de: {
        headline: "Beliebt in <mark>{categoryName}</mark>",
        subheadline: "Jetzt {booksCount} Titel lesen oder anhören"
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.category-book-slider {

  &__headline {

    ::v-deep mark {/* stylelint-disable-line */
      display: block;

      color: $blue;
      @include media(min-width, m ) {
        display: inline-block;
      }
    }
  }
}

</style>
